<template>
  <div class="sentimentCard">
    <el-card class="box-card trading-card sentiment-card">
      <div style="display: flex; justify-content: space-between">
        <div v-if="stock_details.name">
          <div>
            <div
              class="font-weight-600"
              style="font-size: 1.1rem; max-width: 160px"
            >
              {{ stock_details.name }}
            </div>

            <span class="label-xs-bold"
              >₹ {{ stock_details.current_price }}</span
            >&nbsp;
            <span
              style="font-size: 10px"
              :style="[
                stock_details.price_difference >= 0
                  ? { color: '#079e3e' }
                  : { color: '#d60918' },
              ]"
            >
              <span
                class="label-xss-black"
                v-if="stock_details.price_difference >= 0"
                >&#9662;</span
              >
              <span class="label-xss-black" v-else>&#9652;</span>

              &nbsp;
              <span
                >{{ stock_details.price_difference }} ({{
                  stock_details.price_potential
                }}%)</span
              >
            </span>

            <div
              class="input-label-gray"
              style="font-size: 9px"
              v-if="stock_details.modified_datetime"
            >
              {{
                stock_details.modified_datetime | stock_live_price_date_filter
              }}
            </div>

            <div class="flex top-margin-10">
              <el-tag
                v-if="stock_details.sector"
                size="mini"
                class="sector-tag ellipsis"
                effect="plain"
                type="info"
                style="height: 16px; line-height: 15px; font-size: 8px"
              >
                {{ stock_details.sector }}
              </el-tag>

              &nbsp;

              <el-tag
                v-if="stock_details.market_cap_size"
                size="mini"
                class="sector-tag ellipsis"
                effect="plain"
                type="info"
                style="height: 16px; line-height: 15px; font-size: 8px"
              >
                {{ stock_details.market_cap_size }}
              </el-tag>
            </div>
          </div>
        </div>

        <!-- <div>
                            <img src="../assets/images/trading/trade.png" class="cursor-pointer" style="width: 85px;">
                        </div> -->
      </div>

      <div class="flex-space-between top-margin-15">
        <div class="flex">
          <img
            src="../assets/images/trading/sentiment.png"
            class="cursor-pointer"
            style="width: 15px; margin-right: 5px"
          />
          <span class="font-09rem font-weight-600"
            >StockAnts Sentiment Card</span
          >
        </div>

        <div>
          <el-select
            v-model="select_target"
            placeholder="Select"
            size="mini"
            @change="changeTargetPeriod()"
          >
            <el-option
              v-for="(item, index) in target_period_list"
              :key="index"
              :label="item.value"
              :value="item.counter"
            >
            </el-option>
          </el-select>
        </div>
      </div>

      <div
        class="sub-menu-section top-margin-10"
        style="position: unset"
        v-if="stock_details.name"
      >
        <div class="sub-menu-bar-wrapper" style="background: #fff; width: 100%">
          <div class="sub-menu-bar">
            <div
              class="sub-menu-bar-link cursor-pointer"
              @click="setActiveSubMenuLink('MARKET_SENTIMENT')"
              :class="{
                'active-sub-menu-link':
                  active_sub_menu_link == 'MARKET_SENTIMENT',
              }"
            >
              Market Sentiment
            </div>

            <!-- <div class="sub-menu-bar-link cursor-pointer" @click="setActiveSubMenuLink('FORECAST')" :class="{'active-sub-menu-link' : active_sub_menu_link == 'FORECAST'}">
                                    Forecast
                                </div> -->

            <!-- <div class="sub-menu-bar-link cursor-pointer" @click="setActiveSubMenuLink('LOGIC')" :class="{'active-sub-menu-link' : active_sub_menu_link == 'LOGIC'}">
                                    Logic
                                </div> -->
          </div>
        </div>
      </div>

      <div
        class="
          top-margin-25
          text-center
          font-08rem font-weight-500
          primary-theme-color
        "
        v-if="!stock_details.name"
      >
        No data available
      </div>

      <div class="top-margin-10">
        <el-row :gutter="10">
          <el-col
            :xs="24"
            :sm="24"
            :md="12"
            :lg="12"
            :xl="12"
            v-if="active_sub_menu_link == 'MARKET_SENTIMENT'"
          >
            <div
              ref="marketPerformance"
              style="width: 100%; height: 160px"
            ></div>
          </el-col>

          <el-col
            :xs="24"
            :sm="24"
            :md="12"
            :lg="12"
            :xl="12"
            v-if="active_sub_menu_link == 'FORECAST'"
          >
            <div class="forecast-descp">
              <div class="font-1rem secondary-theme-color font-weight-600">
                {{
                  antestimate_details.market_return
                    ? antestimate_details.market_return + "%"
                    : "-"
                }}
              </div>

              <div
                class="font-08rem font-weight-500 top-margin-5"
                style="color: #bfc0d1"
              >
                1Y market return
              </div>
            </div>

            <div class="forecast-descp top-margin-10">
              <div class="font-1rem secondary-theme-color font-weight-600">
                {{
                  antestimate_details.forecasted_market_return
                    ? antestimate_details.forecasted_market_return + "%"
                    : "-"
                }}
              </div>

              <div
                class="font-08rem font-weight-500 top-margin-5"
                style="color: #bfc0d1"
              >
                Forecasted market return
              </div>
            </div>
          </el-col>

          <el-col
            :xs="24"
            :sm="24"
            :md="12"
            :lg="12"
            :xl="12"
            v-if="stock_details.name"
          >
            <div class="antestimate-details">
              <div style="">
                <div class="font-1rem font-weight-600" style="color: #fff">
                  {{
                    antestimate_details.antestimate_no
                      ? "₹" + antestimate_details.antestimate_no
                      : "-"
                  }}
                  <!-- <span class="font-07rem font-weight-500" style="color: #fff;">(23%)</span>  -->
                </div>
              </div>

              <div
                class="font-08rem font-weight-600 top-margin-5"
                style="color: #fff"
              >
                Overall Antestimate
              </div>

              <!-- <el-popover
                                        placement="bottom"
                                        title="Title"
                                        width="200"
                                        trigger="click"
                                        >
                                        <div slot="reference" class="font-07rem font-weight-600 top-margin-10" style="color: #fff;">All Experts <i class="el-icon-caret-bottom"></i></div>
                                    </el-popover> -->
            </div>
          </el-col>
        </el-row>
      </div>

      <!-- <div class="top-margin-20" v-if="active_sub_menu_link == 'MARKET_SENTIMENT'">
                        <div class="flex-space-between">
                            <div class="flex">
                                <img src="../assets/images/asset2.png" class="cursor-pointer" style="width: 15px; margin-right: 5px;">
                                <span class="font-09rem font-weight-600">Verified Knowledge</span>
                            </div>

                            <div class="flex">
                                <div class="period-btn-mini" @click="selectPeriod('1M')" :class="[active_period == '1M' ? 'active-period-btn-mini' : '']">1M</div>
                                <div class="period-btn-mini" @click="selectPeriod('3M')" :class="[active_period == '3M' ? 'active-period-btn-mini' : '']">3M</div>
                                <div class="period-btn-mini" @click="selectPeriod('6M')" :class="[active_period == '6M' ? 'active-period-btn-mini' : '']">6M</div>
                            </div>
                        </div>

                        <div ref="verifiedKnowledgeChart" style="width: 100%; height: 285px;"></div>
                    </div> -->

      <!-- <div class="top-margin-20" v-if="active_sub_menu_link == 'FORECAST'">
                        <div class="flex-space-between">
                            &nbsp;
                        </div>
                        <div ref="marketForecastChart" style="width: 100%; height: 285px;"></div>
                    </div> -->

      <div
        class="
          top-margin-15
          external-link-color
          font-08rem font-weight-500
          text-center
          cursor-pointer
        "
      >
        <span
          v-if="!toggle_forecasted_details"
          @click="toggle_forecasted_details = true"
          ><i class="el-icon-arrow-down"></i> Details</span
        >

        <span
          v-if="toggle_forecasted_details"
          @click="toggle_forecasted_details = false"
          ><i class="el-icon-arrow-up"></i> Details</span
        >
      </div>

      <div class="top-margin-10" v-if="toggle_forecasted_details">
        <table class="forecasted-user-table">
          <thead>
            <tr>
              <th>Profession</th>
              <th>Number of Experts</th>
              <th>Antestimate</th>
            </tr>
          </thead>

          <tbody>
            <tr
              v-for="(item, index) in profession_wise_antestimate_details"
              :key="index"
              :style="[
                index % 2 == 0
                  ? { background: '#fff' }
                  : { background: '#f7faff' },
              ]"
            >
              <td>{{ item.title }}</td>
              <td>{{ item.total_expert }}</td>
              <td>₹{{ item.ants_number }}</td>
            </tr>
          </tbody>
        </table>

        <div
          class="
            top-margin-25
            text-center
            font-08rem font-weight-500
            primary-theme-color
          "
          v-if="!profession_wise_antestimate_details.length"
        >
          No data available
        </div>
      </div>
    </el-card>
  </div>
</template>
<script>
import { TradingPageChartData } from "../mixins/TradingPageChartData";
import { StockDetailsLineChartData } from "../mixins/StockDetailsLineChartData";
import axios from "axios";
import { serverAddr } from "../networkConfig";
import { HelperNetworkCallBack } from "../mixins/Helper";
import { filterCallBack } from "../mixins/filter";
var echarts = require("echarts");
import CripNotice from "crip-vue-notice";

export default {
  name: "SentimentCard",
  props: ["stock_details"],
  data() {
    return {
      stocks_loading: false,
      search_stock: "",
      stocks_list: [],
      stock_type: "BSE",
      selected_trade_type: "BUY",
      target_period: "",
      quantity: "",
      price: "",
      trigger_price: "",
      price_limit: "MARKET",
      trigger_price_type: false,
      validity: "",
      disclosed_quantity: "",
      stop_loss_checked: false,
      stop_loss_trigger: "",
      target_checked: false,
      target: "",
      required_margin: "",
      select_target: "",
      target_period_list: [],
      active_sub_menu_link: "MARKET_SENTIMENT",
      market_performance_chart_instance: null,
      active_period: "1M",
      publish_as_reco: true,
      short_term_duration: "",
      long_term_duration: "",
      short_term_target_period_list: [],
      long_term_target_period_list: [],
      reco_price: "",
      reco_price_potential: "",
      validate_reco_price: false,
      reco_price_error_text: "",
      target_price: "",
      target_price_potential: "",
      validate_target_price: false,
      target_price_error_text: "",
      stop_loss: "",
      stop_loss_potential: "",
      validate_stop_loss: false,
      stop_loss_error_text: "",
      verified_knowledge_chart_instance: null,
      market_forecast_chart_instance: null,
      socket: {},
      profession_wise_antestimate_details: [],
      toggle_forecasted_details: false,
      result_date: "",
      duration: "",
      antestimate_details: {},
      broker_id: Number(localStorage.getItem("selected_broker")),
      validity_list: [],
      duration_list: [],
      is_trading_details_loading: false,
      is_ltp_loading: false,
      bse_ltp: "",
      nse_ltp: "",
      price_type: [],
      is_order_placing: false,
      order_id: null,
    };
  },

  mixins: [
    StockDetailsLineChartData,
    HelperNetworkCallBack,
    filterCallBack,
    TradingPageChartData,
  ],

  async mounted() {
     if (stock) {
        this.initChartInstances();

        setTimeout(() => {
          this.getCommonIndexData();
        }, 400);
      }
      if (!orderType) {
        this.order_id = null;
      }
    if (this.$store.state.selected_order.stock_id) {
      var stock_details = this.$store.state.selected_order;
      this.search_stock = this.$store.state.selected_order.stock_id;

      this.searchStockList(stock_details.symbol);
      this.handleStock(this.search_stock, "limit");
    }
  },

  methods: {
    validateRecoPrice(price, current_price, reco_type) {},

    validateTargetPrice(price, current_price, reco_type) {},

    selectPeriod(period) {
      if (period == "1M") {
        this.active_period = "1M";
      } else if (period == "3M") {
        this.active_period = "3M";
      } else if (period == "6M") {
        this.active_period = "6M";
      }
    },

    initChartInstances() {
      // let verified_knowledge_chart_container = this.$refs["verifiedKnowledgeChart"];
      // this.verified_knowledge_chart_instance = echarts.init(verified_knowledge_chart_container, null, this.initOptions);
      // this.verified_knowledge_chart_instance.showLoading(this.loader_default);      //show loader on chart

      let market_performance_container = this.$refs["marketPerformance"];
      this.market_performance_chart_instance = echarts.init(
        market_performance_container,
        null,
        this.initOptions
      );
      this.market_performance_chart_instance.showLoading(this.loader_default); //show loader on chart
    },

    //refresh volume shockers chart instance
    clearmarketPerformanceChartInstance() {
      this.market_performance_chart_instance.clear();
    },

    //to trigger changes on chart e.g. to reflect changes data
    reRenderMarketPerformanceChartInstance() {
      this.clearmarketPerformanceChartInstance();
      this.market_performance_chart_instance.setOption(
        this.marketPerformanceChart
      );
    },

    clearVerifiedKnowledgeChartInstance() {
      this.verified_knowledge_chart_instance.clear();
    },

    //to trigger changes on graph e.g. to reflect changes data
    reRenderVerifiedKnowledgeChartInstance() {
      this.clearVerifiedKnowledgeChartInstance();
      this.verified_knowledge_chart_instance.setOption(
        this.verifiedKnowledgeChart
      );
    },

    clearMarketForecastChartInstance() {
      this.market_forecast_chart_instance.clear();
    },

    //to trigger changes on graph e.g. to reflect changes data
    reRenderMarketForecastChartInstance() {
      this.clearMarketForecastChartInstance();
      this.market_forecast_chart_instance.setOption(this.marketForecastChart);
    },

    searchStockList(query) {
      // this.clearAllFields();
      this.stocks_list = [];
      serverAddr
        .post("/recommendation/v1/read-stock", {
          search: query,
          key: "stock",
        })
        .then((response) => {
          if (response.data.status) {
            this.stocks_list = response.data.data;
          } else {
            this.stocks_list = [];
          }
        })
        .catch(function (error) {
          console.log("error");
        });
    },
    handleStock(stock, orderType) {
      if (stock) {
        this.initChartInstances();

        setTimeout(() => {
          this.getCommonIndexData();
        }, 400);
      }
      if (!orderType) {
        this.order_id = null;
      }
    },

    async changeTargetPeriod() {
      this.market_performance_chart_instance.showLoading(this.loader_default); //show loader on chart

      this.market_performance_chart_series[0].data = []; //cleared previously filled data
      this.reRenderMarketPerformanceChartInstance(); //render reco details chart

      // get selected target period's obj
      let target_period = this.target_period_list.find((e) => {
        return e.counter == this.select_target;
      });

      if (Object.keys(target_period).length) {
        let reco_details_res =
          await this.getRecoDetailsChartDataNetWorkCallBack(
            target_period.number,
            target_period.duration,
            target_period.year
          ); //called api to get reco details chart data

        if (reco_details_res.data.status) {
          this.antestimate_details = {};

          // this.is_antestimate_chart_data_available = true;    //hide no data labels from chart

          let reco_details = reco_details_res.data.data.market_sentiments;

          this.antestimate_details = {
            antestimate_no: reco_details_res.data.data.ants_number,
            market_return: reco_details_res.data.data.market_return,
            forecasted_market_return:
              reco_details_res.data.data.forecasted_market_return,
          };

          for (let key in reco_details) {
            if (reco_details[key]) {
              let obj = {
                name: key ? key.toUpperCase() : "",
                value: reco_details[key],
                itemStyle: {
                  color:
                    key == "buy"
                      ? "#079e3e"
                      : key == "sell"
                      ? "#d60918"
                      : "#e2ba00",
                },
              };

              this.market_performance_chart_series[0].data.push(obj);
            }
          }

          this.profession_wise_antestimate_details =
            reco_details_res.data.data.profession_wise_data;
        }
      }

      this.market_performance_chart_instance.hideLoading(this.loader_default); //show loader on chart
      this.reRenderMarketPerformanceChartInstance(); //render reco details chart
    },
    setStockDetailsForModifyOrder() {
      var stock_details = this.$store.state.selected_order;
      // AutoFill Data for Modify Order
      this.order_id = stock_details.id;
      this.search_stock = this.$store.state.selected_order.stock_id;
      this.validity = stock_details.product;
      this.quantity = stock_details.quantity;
      this.duration = stock_details.duration;
      this.disclosed_quantity = stock_details.disclosed_quantity;

      var price_limit = stock_details.order_type;
      // if limit
      if (price_limit == "Limit") {
        this.price_limit = "LIMIT";
        this.price = stock_details.price;
      } else {
        this.price_limit = "MARKET";
      }
    },

    getCommonIndexData() {
      this.is_trading_details_loading = true; //enabled loader

      this.market_performance_chart_series[0].data = []; //cleared previously filled data
      this.reRenderMarketPerformanceChartInstance(); //render reco details chart

      this.stock_details = {};
      this.antestimate_details = {};
      this.target_period_list = [];
      this.profession_wise_antestimate_details = [];
      this.validity_list = [];
      this.duration_list = [];
      this.price_type = [];
      this.bse_ltp = "";
      this.nse_ltp = "";

      this.order_id = null;
      this.validity = "";
      this.quantity = "";
      this.duration = "";
      this.disclosed_quantity = "";
      this.price_limit = "MARKET";
      this.price = "";

      // get stockdetails for modify order
      if (this.$store.state.selected_order.stock_id) {
        this.setStockDetailsForModifyOrder();
      }
      // this.getStockPerformanceNetWorkCallBack()
      axios
        .all([
          this.getStockDetailsNetWorkCallBack(),
          this.getTargetperiodNetWorkCallBack(),
          this.getDeliverType(),
          this.getLTPPrice(),
        ])
        .then(
          // stock_performance_res
          axios.spread(
            async function (
              stock_details_res,
              target_period_res,
              delivery_type_res,
              ltp_res
            ) {
              // for stock details
              if (
                stock_details_res.status &&
                stock_details_res.data.data.length
              ) {
                this.stock_details = stock_details_res.data.data[0];

              }

              // for target period list
              if (
                target_period_res.data.status &&
                target_period_res.data.data.length
              ) {
                this.target_period_list = target_period_res.data.data;

                this.select_target = target_period_res.data.data[0].counter; //select by default first value

                this.result_date = target_period_res.data.data[0].result_date;
                this.duration = target_period_res.data.data[0].duration;

                // this.is_expert_list_loading = true;         //enabled loader
                // api to get market experts list
                // let experts_list = await this.getExpertsListNetWorkCallBack();

                // if(experts_list.data.status && experts_list.data.data.length){
                //     this.experts_list = experts_list.data.data;

                //     this.expert_details_page_no = experts_list.data.pagination_dict.current_page;
                //     this.expert_details_total_entries = experts_list.data.pagination_dict.total_entries;
                //     this.expert_details_total_no_of_pages = experts_list.data.pagination_dict.total_pages;
                // }else{
                //     this.experts_list = [];
                // }
                // this.is_expert_list_loading = false;         //disabled loader

                let reco_details_res =
                  await this.getRecoDetailsChartDataNetWorkCallBack(
                    target_period_res.data.data[0].number,
                    target_period_res.data.data[0].duration,
                    target_period_res.data.data[0].year
                  ); //called api to get reco details chart data

                if (reco_details_res.data.status) {
                  // this.is_antestimate_chart_data_available = true;    //hide no data labels from chart

                  let reco_details =
                    reco_details_res.data.data.market_sentiments;

                  this.antestimate_details = {
                    antestimate_no: reco_details_res.data.data.ants_number,
                    market_return: reco_details_res.data.data.market_return,
                    forecasted_market_return:
                      reco_details_res.data.data.forecasted_market_return,
                  };

                  for (let key in reco_details) {
                    if (reco_details[key]) {
                      let obj = {
                        name: key ? key.toUpperCase() : "",
                        value: reco_details[key],
                        itemStyle: {
                          color:
                            key == "buy"
                              ? "#079e3e"
                              : key == "sell"
                              ? "#d60918"
                              : "#e2ba00",
                        },
                      };

                      this.market_performance_chart_series[0].data.push(obj);
                    }
                  }

                  this.profession_wise_antestimate_details =
                    reco_details_res.data.data.profession_wise_data;
                } else {
                  // this.is_antestimate_chart_data_available = false;    //show no data labels from chart
                }
              } else {
                this.target_period_list = [];
                this.select_target = "";
                // this.experts_list = [];

                // this.is_antestimate_chart_data_available = false;    //show no data labels from chart
              }

              this.market_performance_chart_instance.hideLoading(
                this.loader_default
              ); //show loader on chart
              this.reRenderMarketPerformanceChartInstance(); //render reco details chart

              if (delivery_type_res.data.status) {
                if (delivery_type_res.data.data.product_type.length) {
                  this.validity_list = delivery_type_res.data.data.product_type;

                  //  Don't set default validity while modifing order
                  if (!this.$store.state.selected_order.stock_id) {
                    this.validity = this.validity_list[0].value;
                  }
                }

                if (delivery_type_res.data.data.duration.length) {
                  this.duration_list = delivery_type_res.data.data.duration;

                  this.target_period = this.duration_list[0].value;
                }

                if (delivery_type_res.data.data.segment.length) {
                  this.price_type = delivery_type_res.data.data.segment;

                  this.stock_type = this.price_type[0].value;
                }
              }

              if (ltp_res.data.status && ltp_res.data.data.length) {
                for (let i = 0; i < ltp_res.data.data.length; i++) {
                  if (ltp_res.data.data[i].identity == "BSE") {
                    this.bse_ltp = ltp_res.data.data[i].ltp;
                  } else if (ltp_res.data.data[i].identity == "NSE") {
                    this.nse_ltp = ltp_res.data.data[i].ltp;
                  }
                }
              }

              this.is_trading_details_loading = false; //disabled loader
            }.bind(this)
          )
        )
        .catch((err) => {
          console.log(err);
          this.is_trading_details_loading = false; //disabled loader

          // this.is_expert_list_loading = false;         //disabled loader

          // this.experts_list = [];

          // this.is_stock_performance_chart_data_available = false;    //to show no data lables
          // this.stock_performance_chart_instance.hideLoading(this.loader_default);      //hide loader on chart
          // this.reRenderStockPerformanceChartInstance();      //render market performance chart

          this.market_performance_chart_instance.hideLoading(
            this.loader_default
          ); //hide loader on chart
          this.reRenderMarketPerformanceChartInstance(); //render reco details chart
        })
        .finally(() => {
          this.is_trading_details_loading = false; //disabled loader
        });
    },
    // modifyOrder(){

    // },

    placeOrder(orderType) {
      if (this.price_limit != "MARKET" && this.quantity && this.price) {
        this.saveOrder(orderType);
      } else if (this.price_limit == "MARKET" && this.quantity) {
        this.saveOrder(orderType);
      } else {
        this.$message({
          customClass: "notification-tag",
          showClose: true,
          message: "Please fill all required fileds",
          type: "error",
        });
      }
    },

    saveOrder(orderType) {
      this.is_order_placing = true; //displayed loader
      var apIUrl;
      var obj = {
        broker_id: Number(this.broker_id),
        stock_id: this.search_stock,
        transaction_type: this.selected_trade_type,
        exchange: this.stock_type,
        order_type: this.price_limit,
        validity: this.target_period,
        product_type: this.validity,
        price: this.price_limit == "MARKET" ? null : this.price,
        quantity: this.quantity,
        disclosed_quantity: this.disclosed_quantity
          ? this.disclosed_quantity
          : null,
      };
      if (orderType == "modify") {
        apIUrl = "/trade/v1/modify_order";
        obj.order_id = this.order_id;
        obj.stopPrice = 0;
      } else if (orderType == "place") {
        apIUrl = "/trade/v1/place_order";
        obj.stoploss = 0;
      }
      serverAddr
        .post(apIUrl, obj)
        .then((response) => {
          if (response.data.status) {
            new CripNotice({
              title: "Success",
              description: response.data.validation,
              type: "success",
              duration: 3,
            });
          }

          this.is_order_placing = false; //hide loader
        })
        .catch(
          function (error) {
            console.log(error);
            this.is_order_placing = false; //hide loader
          }.bind(this)
        );
    },

    // api to get stocks details
    getStockDetailsNetWorkCallBack() {
      return serverAddr
        .get(`/market_dashboard/indices_info?stock_id=${this.search_stock}`, {})
        .then((response) => {
          return response;
        })
        .catch(
          function (error) {
            console.log(error);
          }.bind(this)
        );
    },

    // api to get target period of market performance of stockants
    getTargetperiodNetWorkCallBack() {
      return serverAddr
        .get(
          `/market_dashboard/target_period_dropdown?stock_id=${this.search_stock}`,
          {}
        )
        .then((response) => {
          return response;
        })
        .catch(
          function (error) {
            console.log(error);
          }.bind(this)
        );
    },

    getDeliverType() {
      return serverAddr
        .post(`/trade/v1/setting`, {
          broker_id: Number(this.broker_id),
        })
        .then((response) => {
          return response;
        })
        .catch(
          function (error) {
            console.log(error);
          }.bind(this)
        );
    },

    // api to get ltp price
    getLTPPrice() {
      return serverAddr
        .post(`/trade/v1/ltp`, {
          stock_id: this.search_stock,
          broker_id: Number(this.broker_id),
        })
        .then((response) => {
          return response;
        })
        .catch(
          function (error) {
            console.log(error);
          }.bind(this)
        );
    },

    async refreshLTP() {
      this.is_ltp_loading = true;

      let ltp_res = await this.getLTPPrice();

      if (ltp_res.data.status && ltp_res.data.data.length) {
        for (let i = 0; i < ltp_res.data.data.length; i++) {
          if (ltp_res.data.data[i].exchange == "BSE") {
            this.bse_ltp = ltp_res.data.data[i].ltp;
          } else if (ltp_res.data.data[i].exchange == "NSE") {
            this.nse_ltp = ltp_res.data.data[i].ltp;
          }
        }
      }

      this.is_ltp_loading = false;
    },

    // api to get reco details chart data
    getRecoDetailsChartDataNetWorkCallBack(number, duration, year) {
      return serverAddr
        .get(
          `/market_dashboard/market_performance_stockants?stock_id=${this.search_stock}&duration=${duration}&number=${number}&year=${year}`,
          {}
        )
        .then((response) => {
          return response;
        })
        .catch(
          function (error) {
            console.log(error);
          }.bind(this)
        );
    },

    async setActiveSubMenuLink(label) {
      this.toggle_forecasted_details = false;

      if (label == "MARKET_SENTIMENT") {
        this.active_sub_menu_link = "MARKET_SENTIMENT";

        this.market_performance_chart_series[0].data = [];
        this.reRenderMarketPerformanceChartInstance();

        // if(this.$refs['marketForecastChart']){
        //     this.$refs.marketForecastChart.getElementsByTagName('div')[0].style.height = '0px';
        // }

        // reinit chart instances
        setTimeout(async () => {
          // let verified_knowledge_chart_container = this.$refs["verifiedKnowledgeChart"];
          // this.verified_knowledge_chart_instance = echarts.init(verified_knowledge_chart_container, null, this.initOptions);
          // this.verified_knowledge_chart_instance.showLoading(this.loader_default);      //show loader on chart

          let market_performance_container = this.$refs["marketPerformance"];
          this.market_performance_chart_instance = echarts.init(
            market_performance_container,
            null,
            this.initOptions
          );

          this.$refs.marketPerformance.getElementsByTagName(
            "div"
          )[0].style.height = "160px";

          let duration = this.target_period_list.filter((e) => {
            return this.select_target == e.counter;
          });

          if (duration.length) {
            // get result date and duration from selected target period
            this.result_date = duration[0].result_date;
            this.duration = duration[0].duration;

            this.market_performance_chart_instance.showLoading(
              this.loader_default
            ); //show loader on chart

            let reco_details_res =
              await this.getRecoDetailsChartDataNetWorkCallBack(
                duration[0].number,
                duration[0].duration,
                duration[0].year
              ); //called api to get reco details chart data

            if (
              reco_details_res.data.status &&
              reco_details_res.data.data.market_sentiments
            ) {
              // this.is_antestimate_chart_data_available = true;    //hide no data labels from chart

              let reco_details = reco_details_res.data.data.market_sentiments;
              // this.antestimate = reco_details_res.data.data.ants_number;

              for (let key in reco_details) {
                if (reco_details[key]) {
                  let obj = {
                    name: key ? key.toUpperCase() : "",
                    value: reco_details[key],
                    itemStyle: {
                      color:
                        key == "buy"
                          ? "#079e3e"
                          : key == "sell"
                          ? "#d60918"
                          : "#e2ba00",
                    },
                  };

                  this.market_performance_chart_series[0].data.push(obj);
                }
              }
            } else {
              // this.is_antestimate_chart_data_available = false;    //show no data labels from chart
            }
          }

          this.market_performance_chart_instance.hideLoading(
            this.loader_default
          ); //show loader on chart
          this.reRenderMarketPerformanceChartInstance(); //render reco details chart

          // this.verified_knowledge_chart_instance.hideLoading(this.loader_default);      //show loader on chart
          // this.reRenderVerifiedKnowledgeChartInstance();      //render reco details chart
        }, 200);
      } else if (label == "FORECAST") {
        this.active_sub_menu_link = "FORECAST";

        if (this.$refs["marketPerformance"]) {
          this.$refs.marketPerformance.getElementsByTagName(
            "div"
          )[0].style.height = "0px";
        }

        // setTimeout(() => {

        //     // init chart instance
        //     // let market_forecast_container = this.$refs["marketForecastChart"];
        //     // this.market_forecast_chart_instance = echarts.init(market_forecast_container, null, this.initOptions);
        //     // this.$refs.marketForecastChart.getElementsByTagName('div')[0].style.height = '285px';

        //     // this.market_forecast_chart_instance.showLoading(this.loader_default);

        //     for(let i=0; i<4; i++){
        //         let obj = {
        //             type: 'line',
        //             lineStyle: {
        //                 type: i == 2 ? 'dashed' : 'solid'
        //             },
        //             showSymbol: false,
        //             name: i == 0 ? 'Broker' : i == 1 ? 'Analyst' : i == 2 ? 'Fianancial Advisor' : 'Retail',
        //             data: i == 0 ?  [15, 23, 24, 18, 15, 17] : i == 1 ? [null, null, null, 18, 13, 14] : i == 2 ? [null, null, null, 18, 25, 30] : [null, null, null, 18, 12, 14],
        //             itemStyle: { color: i == 0 ? '#8b8ba0' : i == 1 ? '#f77f59' : i == 1 ? '#03d899' : '#806de2'}
        //         }

        //         this.market_forecast_chart_series.push(obj);
        //     }

        //     this.market_forecast_chart_instance.hideLoading(this.loader_default);      //show loader on chart
        //     this.reRenderMarketForecastChartInstance();
        // }, 300)
      } else if (label == "LOGIC") {
        this.active_sub_menu_link = "LOGIC";

        if (this.$refs["marketPerformance"]) {
          this.$refs.marketPerformance.getElementsByTagName(
            "div"
          )[0].style.height = "0px";
        }

        // if(this.$refs['marketForecastChart']){
        //     this.$refs.marketForecastChart.getElementsByTagName('div')[0].style.height = '0px';
        // }
      }
    },
  },

  computed: {
    getOrderId() {
      return this.$store.state.selected_order_id;
    },

    getSelectedOrder() {
      return this.$store.state.selected_order;
    },
  },

  beforeDestroy() {
    // this.socket.close();
    this.$store.commit("commitOrderId", "");
    this.$store.commit("commitSelectedOrder", {});
  },
};
</script>

<style lang="scss" scoped>
@import "../css/variable.scss";
@import "../css/common.scss";

.Trade {
  .select-options-dropdown .el-input__inner {
    font-size: 0.8rem;
    height: 32px !important;
    border-bottom-left-radius: 40px;
    border-top-left-radius: 40px;
  }

  .el-select-dropdown__item {
    line-height: 0;
  }

  .trading-type-btn {
    padding: 6px;
    border-radius: 10px;
    max-width: 100px;
    cursor: pointer;
    border: 1px solid #ddd;
    color: #000;
    font-size: 0.8rem;
    font-weight: 500;
    text-align: center;
  }

  .active-buy-btn {
    background: #d1ffd1;
    border-color: #71cb89;
  }

  .active-sell-btn {
    background: #ffdbdb;
    border-color: #f28a8f;
  }

  .order-btn {
    color: #fff;
    border-radius: 10px;
  }

  .antestimate-details {
    background: $secondary-theme-color;
    border-radius: 10px;
    padding: 10px;
  }

  .potential-return-value {
    font-size: 0.7rem;
    font-weight: 600;
    position: absolute;
    top: 8px;
    right: 8px;
    // right: 30%;
    z-index: 1;
    color: #979797;
  }

  .rupees-symbol {
    position: absolute;
    top: 7px;
    left: 15px;
    z-index: 1;
    font-size: 0.9rem;
    color: black;
    font-weight: bold;
  }

  .forecast-descp {
    background: #f3f3ff;
    border-radius: 10px;
    padding: 10px 10px 10px 20px;
  }

  .forecasted-user-table {
    width: 100%;
    border-collapse: collapse;

    th {
      color: #a5a6a8;
      font-size: 13px;
      font-weight: 600;
      padding: 5px;
      border-bottom: 1px solid #ddd;
    }

    td {
      font-size: 12px;
      font-weight: 500;
      text-align: center;
      padding: 15px 10px;
    }
    td:first-child {
      font-weight: 600;
    }
  }
}
</style>


<style lang="scss">
@import "../css/variable.scss";
@import "../css/common.scss";

.Trade {
  .trading-card {
    border-radius: 10px;
    box-shadow: none;
  }

  .el-checkbox__label {
    font-size: 0.8rem;
  }

  .el-radio__label {
    color: #000;
    font-size: 0.8rem;
  }

  .el-radio__inner {
    height: 12px;
    width: 12px;
  }

  .el-checkbox__input.is-checked + .el-checkbox__label {
    color: #000;
  }
  .el-checkbox__input.is-checked .el-checkbox__inner {
    background-color: $secondary-theme-color;
    border-color: $secondary-theme-color;
  }
  .el-radio__input.is-checked + .el-radio__label {
    color: $secondary-theme-color;
  }
  .el-radio__input.is-checked .el-radio__inner {
    border-color: $secondary-theme-color;
    background: $secondary-theme-color;
  }

  .target-price-input-section .el-input__inner::placeholder {
    font-size: 0.8rem;
    font-weight: 500;
  }

  .target-price-input .el-input__inner {
    border-radius: 25px;
  }

  .quarter-tag {
    width: 100%;
    input {
      border-radius: 25px;
      // height: 25px;
    }
    input::placeholder {
      // color: $primary-theme-color;
      // font-size: 10px;
      font-weight: 500;
    }
  }
}
</style>
